(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection-tab"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
    var tabs = document.querySelectorAll(".tab");
    var tabContents = document.querySelectorAll(".tab-content");
    var tabLinks = document.querySelectorAll(".tab-link");
    // console.log('tabLinks', tabLinks);
    // console.log('tabs', tabs);
    // console.log('tabContents', tabContents);

    document.querySelector('.tab-0').classList.remove('inactive');
    document.querySelector('.tab-0').classList.add('active');

    document.querySelector('.tab-content-0').classList.remove('hide');
    document.querySelector('.tab-content-0').classList.add('active');

    if (tabLinks.length > 0) {
      document.querySelector('.tab-link-0').classList.remove('hide');
      document.querySelector('.tab-link-0').classList.add('active');
    }

    tabs.forEach(function(tab, index) {
        tab.addEventListener("click", function(event) {
            event.preventDefault();

            tabs.forEach(function(content) {
                content.classList.remove("active");
                content.classList.add("inactive");
            });

            tabContents.forEach(function(content) {
                content.classList.remove("active");
                content.classList.add("hide");
            });

            if (tabLinks) {
              tabLinks.forEach(function(link) {
                link.classList.remove("active");
                link.classList.add("hide");
              });
            }

            var selectedLink = document.querySelector(`.tab-link-${index}`);
            var selectedTab = document.querySelector(`.tab-${index}`);
            var selectedTabContent = document.querySelector(`.tab-content-${index}`);

            if (selectedLink) {
              selectedLink.classList.remove('hide');
              selectedLink.classList.add("active");
            }

            if(selectedTab) {
              selectedTab.classList.remove('inactive');
              selectedTab.classList.add("active");
            }

            if (selectedTabContent) {
              selectedTabContent.classList.remove('hide');
              selectedTabContent.classList.add("active");
            }
        });
    });
});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tab-productpage"] && !Shopify.designMode) return;
  try {
    
  /*** Tab Setting ***/

  document.addEventListener("DOMContentLoaded", function(){

  let tabs = document.querySelectorAll(".pdp-tab-btn")
  if(!tabs.length) return

  tabs.forEach(btn => {

  btn.addEventListener("click", function(){

  let tab = this.dataset.tab

  document.querySelectorAll(".pdp-tab-btn").forEach(b=>{
  b.classList.remove("active")
  })

  document.querySelectorAll(".pdp-panel").forEach(p=>{
  p.classList.remove("active")
  })

  this.classList.add("active")

  let panel = document.querySelector(`[data-content="${tab}"]`)
  if(panel) panel.classList.add("active")

  })

  })

  })

  let usedProducts = []

  /*** Recent ***/

  document.addEventListener("DOMContentLoaded", function(){

  let tab = document.querySelector(".pdp-tabs")
  if(!tab) return

  let handle = tab.dataset.productHandle

  let viewed = JSON.parse(localStorage.getItem("recentProducts")) || []

  viewed = viewed.filter(p => p !== handle)

  viewed.unshift(handle)

  viewed = viewed.slice(0,16)

  localStorage.setItem("recentProducts", JSON.stringify(viewed))

  })

  /*** History ***/

  document.addEventListener("DOMContentLoaded", async function(){

  let tab = document.querySelector(".pdp-tabs")
  if(!tab) return

  let viewed = JSON.parse(localStorage.getItem("recentProducts")) || []
  let container = document.querySelector("#history-products")
  let currentHandle = tab.dataset.productHandle

  for (let handle of viewed){

  if(handle == currentHandle) continue
  if(usedProducts.includes(handle)) continue

  let res = await fetch(`/products/${handle}?view=card`)
  if(!res.ok) continue

  let html = await res.text()

  container.insertAdjacentHTML(
  "beforeend",
  `<div class="swiper-slide">${html}</div>`
  )

  usedProducts.push(handle)

  }
  
  let historyCount = document.querySelectorAll("#history-products .swiper-slide").length
  document.querySelector("#history-count").textContent = historyCount

  initRecommendationSwiper()

  /* init product card script */

  if (window.theme && theme.initGridItemSlider) {
  theme.initGridItemSlider()
  }

  })

  /*** suggestion ***/

  document.addEventListener("DOMContentLoaded", async function(){

  let tab = document.querySelector(".pdp-tabs")
  if(!tab) return

  let container = document.querySelector("#suggestion-products")
  if(!container) return

  let productId = tab.dataset.productId
  let currentHandle = tab.dataset.productHandle

  let res = await fetch(`/recommendations/products.json?product_id=${productId}&limit=16`)
  if(!res.ok) return

  let data = await res.json()

  for (let product of data.products){

  if(product.handle === currentHandle) continue
  if(usedProducts.includes(product.handle)) continue

  let resCard = await fetch(`/products/${product.handle}?view=card`)
  if(!resCard.ok) continue

  let html = await resCard.text()

  container.insertAdjacentHTML(
  "beforeend",
  `<div class="swiper-slide">${html}</div>`
  )

  usedProducts.push(product.handle)
  
  }

  let suggestionCount = document.querySelectorAll("#suggestion-products .swiper-slide").length
  document.querySelector("#suggestion-count").textContent = suggestionCount

  initRecommendationSwiper()

  /* re-init product card */

  if (window.theme && theme.initGridItemSlider) {
  theme.initGridItemSlider()
  }

  })  

function initRecommendationSwiper(){

new Swiper(".history-swiper",{
slidesPerView:4,
spaceBetween:16,
navigation:{
nextEl:".swiper-button-next",
prevEl:".swiper-button-prev"
},
breakpoints:{
320:{slidesPerView:2},
768:{slidesPerView:3},
1024:{slidesPerView:4}
}
})

new Swiper(".suggestion-swiper",{
slidesPerView:4,
spaceBetween:16,
navigation:{
nextEl:".swiper-button-next",
prevEl:".swiper-button-prev"
},
breakpoints:{
320:{slidesPerView:2},
768:{slidesPerView:3},
1024:{slidesPerView:4}
}
})

if(document.querySelector(".promotion-swiper")){
new Swiper(".promotion-swiper",{
slidesPerView:4,
spaceBetween:16,
navigation:{
nextEl:".swiper-button-next",
prevEl:".swiper-button-prev"
},
breakpoints:{
320:{slidesPerView:2},
768:{slidesPerView:3},
1024:{slidesPerView:4}
}
})
}

}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tap-collection"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('.collection-tab-section').forEach(section => {

    function getMode() {
      return window.innerWidth <= 768 ? 'mobile' : 'desktop';
    }

    function initSwiper(container) {
      if (!container || container.offsetParent === null) return;

      const mode = getMode();

      if (container.swiper) {
        if (container.dataset.swiperMode === mode) {
          container.swiper.update();
          container.swiper.navigation.update();
          return;
        }

        container.swiper.destroy(true, true);
      }

      const isMobile = mode === 'mobile';

      const perRow = isMobile
        ? Number(container.dataset.colsMobile || 2)
        : Number(container.dataset.colsDesktop || 4);

      const rows = isMobile
        ? Number(container.dataset.maxMrow || 1)
        : Number(container.dataset.maxRows || 1);

      const tabContent = container.closest('.tab-content');
      if (!tabContent) return;

      const useArrowOnly = container.dataset.arrowOnly === 'true';

      const nextEl = isMobile && useArrowOnly
        ? tabContent.querySelector('.arrow_only.tab_collection_next')
        : tabContent.querySelector('.collection-toolbar__right .tab_collection_next');

      const prevEl = isMobile && useArrowOnly
        ? tabContent.querySelector('.arrow_only.tab_collection_prev')
        : tabContent.querySelector('.collection-toolbar__right .tab_collection_prev');

      container.dataset.swiperMode = mode;

      new Swiper(container, {
        slidesPerView: perRow,
        grid: {
          rows: rows,
          fill: 'row'
        },
        spaceBetween: isMobile ? 8 : 16,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl
        }
      });
    }

    function initActiveSwiper() {
      const activeContent = section.querySelector('.tab-content.active');
      const slider = activeContent?.querySelector('.js-plp-slider');
      initSwiper(slider);
    }

    initActiveSwiper();

    section.querySelectorAll('.tab').forEach(tab => {
      tab.addEventListener('click', () => {
        const key = tab.dataset.tab;

        section.querySelectorAll('.tab').forEach(t => t.classList.remove('active'));
        section.querySelectorAll('.tab-content').forEach(c => c.classList.remove('active'));

        tab.classList.add('active');

        const content = section.querySelector(`.tab-content[data-tab="${key}"]`);
        if (!content) return;

        content.classList.add('active');

        requestAnimationFrame(() => {
          const slider = content.querySelector('.js-plp-slider');
          initSwiper(slider);
        });
      });
    });

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        initActiveSwiper();
      }, 200);
    });

  });
});

  } catch(e) { console.error(e); }
})();
})();
